const WATCHING_KEY = 'shopsmt_product_watching';
const SEARCH_WATCHING_KEY = 'shopsmt_search_watching';
const ALERT_EMAIL_KEY = 'shopsmt_alert_email';

function readJson(key) {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null || raw === '') {
      return null;
    }
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function writeJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* localStorage unavailable */
  }
}

/**
 * @returns {Set<string>}
 */
function readWatchingUrls() {
  const data = readJson(WATCHING_KEY);
  if (!Array.isArray(data)) {
    return new Set();
  }

  return new Set(
    data.filter((url) => typeof url === 'string' && url.trim() !== ''),
  );
}

function writeWatchingUrls(urls) {
  writeJson(WATCHING_KEY, [...urls]);
}

/**
 * @param {string} productUrl
 * @returns {boolean}
 */
export function isProductWatching(productUrl) {
  const url = typeof productUrl === 'string' ? productUrl.trim() : '';
  if (url === '') {
    return false;
  }

  return readWatchingUrls().has(url);
}

/**
 * @param {string} productUrl
 */
export function markProductWatching(productUrl) {
  const url = typeof productUrl === 'string' ? productUrl.trim() : '';
  if (url === '') {
    return;
  }

  const watching = readWatchingUrls();
  watching.add(url);
  writeWatchingUrls(watching);
}

/**
 * @param {string} productUrl
 */
export function clearProductWatching(productUrl) {
  const url = typeof productUrl === 'string' ? productUrl.trim() : '';
  if (url === '') {
    return;
  }

  const watching = readWatchingUrls();
  watching.delete(url);
  writeWatchingUrls(watching);
}

/**
 * @returns {Set<string>}
 */
function readSearchWatchingPaths() {
  const data = readJson(SEARCH_WATCHING_KEY);
  if (!Array.isArray(data)) {
    return new Set();
  }

  return new Set(
    data.filter((path) => typeof path === 'string' && path.trim() !== ''),
  );
}

function writeSearchWatchingPaths(paths) {
  writeJson(SEARCH_WATCHING_KEY, [...paths]);
}

/**
 * @param {string} searchPath
 * @returns {boolean}
 */
export function isSearchWatching(searchPath) {
  const path = typeof searchPath === 'string' ? searchPath.trim() : '';
  if (path === '') {
    return false;
  }

  return readSearchWatchingPaths().has(path);
}

/**
 * @param {string} searchPath
 */
export function markSearchWatching(searchPath) {
  const path = typeof searchPath === 'string' ? searchPath.trim() : '';
  if (path === '') {
    return;
  }

  const watching = readSearchWatchingPaths();
  watching.add(path);
  writeSearchWatchingPaths(watching);
}

/**
 * @param {string} searchPath
 */
export function clearSearchWatching(searchPath) {
  const path = typeof searchPath === 'string' ? searchPath.trim() : '';
  if (path === '') {
    return;
  }

  const watching = readSearchWatchingPaths();
  watching.delete(path);
  writeSearchWatchingPaths(watching);
}

/**
 * @returns {string}
 */
export function getSavedAlertEmail() {
  try {
    const email = localStorage.getItem(ALERT_EMAIL_KEY);
    return typeof email === 'string' ? email.trim() : '';
  } catch {
    return '';
  }
}

/**
 * @param {string} email
 */
export function setSavedAlertEmail(email) {
  const value = typeof email === 'string' ? email.trim() : '';
  if (value === '') {
    return;
  }

  try {
    localStorage.setItem(ALERT_EMAIL_KEY, value);
  } catch {
    /* localStorage unavailable */
  }
}
